import { api } from '@@/services//api';

export const roomApi = api.injectEndpoints({
  endpoints: (builder) => ({
    fetchAuthorizedRooms: builder.query<Alacaza.Room[], string>({
      query: (propertyId) => `partners/properties/${propertyId}/rooms`,
      providesTags: ['Rooms'],
    }),
    createRoom: builder.mutation<Alacaza.Room, Omit<Alacaza.Room, 'id'>>({
      query: (body) => {
        return {
          url: `partners/properties/${body.propertyId}/rooms`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: ['Rooms'],
    }),
  }),
});

export const { useCreateRoomMutation, useFetchAuthorizedRoomsQuery } = roomApi;
